import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { Box, Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  processId: string
  id: string
  status: string
}

export const RowActions = ({ processId, status, id }: Props) => {
  const { pathname } = useLocation()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { category } = useParams()
  const path = navigation.processes.template.id.processInstance.fullPath({
    category: category as string,
    id: processId,
    materializedProcessId: id,
  })

  const navigateTo = (to: string) => {
    navigate(to, {
      state: {
        backTo: pathname,
      },
    })
  }

  const completeTitle = i18n.t('processes.materialize_process.table.actions.complete_category')
  const removeTitle = i18n.t('common.remove')

  return (
    <Box flexDirection="row" justifyContent="flexEnd" gap="s8">
      {'finalized' !== status && (
        <PopoverMenu type="list">
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
          <PopoverMenu.Content side="bottom" align="end">
            <PopoverMenu.RouterOption
              title={completeTitle}
              to={{
                pathname: navigation.processes.template.id.employees.updateStatus.fullPath({
                  category: category as string,
                  id: processId,
                  materializedProcessId: id,
                }),
              }}
            />
            <PopoverMenu.RouterOption
              title={removeTitle}
              danger
              to={{
                pathname: navigation.processes.template.id.employees.removeMaterialized.fullPath({
                  category: category as string,
                  id: processId,
                  materializedProcessId: id,
                }),
              }}
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      )}
      <Button onClick={() => navigateTo(path)} type="secondary" iconName="arrow-right" />
    </Box>
  )
}
